/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate, useParams } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import Detail from '../pages/beceipt/evidenceReport/detail/Detail'
import SiDetail from '../pages/siteIntelligence/siReport/SiReportDetail'
import SiReportPrint from '../pages/siteIntelligence/siReport/SiReportPrint'
import { App } from '../App'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const SiteInspectReportRedirect: FC = () => {
  const { id } = useParams()
  return <Navigate to={`/siteinspect/report/en/${id}`} replace />
}

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
          <Route path='compelling-evidence/:id' element={<Detail />} />
          <Route path='siteinspect/report/:id' element={<SiteInspectReportRedirect />} />
          <Route path='siteinspect/report/:language/:id' element={<SiDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
